var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mentee-info"},[_c('div',[_c('div',{staticClass:"mentee-info-left"},[_c('zlr-menu',{attrs:{"menuList":_vm.menuList}})],1),_c('div',{staticClass:"mentee-info-right"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }